<template>
  <div id="page-persona-details">

    <div class="mb-4">
      <h1>Create Persona</h1>
    </div>
    <persona-form v-model="model" :loading="loading" ref="personasForm"/>

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
            @click="$router.push({ name: 'personas.fulweb.list' })"
            class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            @click="create"
            class="my-4"
            color="light"
          >
            Create
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import PersonaForm from "@/views/pages/personas/fulweb/PersonaForm";
import NotificationMixin from "@/components/mixins/NotificationMixin";

export default {
  name: "PersonaCreate",
  components: {
    PersonaForm
  },
  mixins: [NotificationMixin],
  data() {
    return {
      model: {},
      loading: false,
    };
  },
  methods: {
    getParams() {
      return {
        ...this.model
      };
    },
    getReferenceId(fieldName) {
      if (!this.model[fieldName]) {
        return null;
      }

      return this.model[fieldName].id || null;
    },
    async create() {
      if (!this.$refs.personasForm.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();

      //  return;
      try {
        const {data} = await this.$api.fulwebPersonas.create(params);
        this.notifySuccess('Persona created');
        this.$router.back();
      } catch (e) {
        this.notifyError('Persona failed to be created');
        console.error(e)
      } finally {
        this.loading = false;
        this.$router.push({ name: 'personas.fulweb.list'}).catch(() => {});
      }
    }
  },
};
</script>

<style scoped>

</style>
